module.exports = __webpack_public_path__ + "img/img6.e4ce6217.png";